"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var account_1 = tslib_1.__importDefault(require("./account"));
var state_1 = tslib_1.__importDefault(require("./state"));
var wcclassification_1 = tslib_1.__importDefault(require("./wcclassification"));
var WCCodeResource = /** @class */ (function (_super) {
    tslib_1.__extends(WCCodeResource, _super);
    function WCCodeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WCCodeResource.endpoint = '/wccodes';
    WCCodeResource.MODEL_NAME = 'wccode';
    WCCodeResource.related = {
        account: account_1.default,
        state: state_1.default,
        wc_classification: wcclassification_1.default,
    };
    return WCCodeResource;
}(base_1.default));
exports.default = WCCodeResource;
//# sourceMappingURL=wccode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/wccode.js
// module id = XDKQ
// module chunks = 0